export default __webpack_public_path__ + "static/media/7_Leonardo-Dicaprio.9bd552e6.jpg";